import { atom } from "jotai";

import { API } from "@aws-amplify/api";

import { customerAccessTokenCreateWithMultipassQuery } from "../graphql/mutations";

const fetchCAT = async (value: string) => {
  const response = (await API.graphql({
    query: customerAccessTokenCreateWithMultipassQuery,
    variables: {
      multipassToken: value,
    },
  })) as any;

  if (
    response.data.customerAccessTokenCreateWithMultipass.customerUserErrors
      .length > 0
  ) {
    console.error(
      response.data.customerAccessTokenCreateWithMultipass.customerUserErrors,
    );
    return;
  } else {
    return response.data.customerAccessTokenCreateWithMultipass
      .customerAccessToken.accessToken;
  }
};

let multipassToken: string | null;

export const multipassTokenAtom = atom(
  (get) => multipassToken,
  (get, set, value: string | null) => {
    multipassToken = value;
    if (value) {
      fetchCAT(value).then((cat) => {
        if (cat) {
          set(customerAccessTokenAtom, cat);
        }
      });
    }
  },
);

export const customerAccessTokenAtom = atom<string | null>(null);
